<template>
   <div class="block-view">
      <div class="mt-3 pt-3">
         <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
            <ol class="breadcrumb">
               <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Content Library</li>
               <li class="breadcrumb-item clickable-row" aria-current="page" @click="goToMainPage">Content Block</li>
               <li class="breadcrumb-item " aria-current="page"> {{ this.title }} </li>
            </ol>
         </nav>
      </div>

      <div>
         <BlockDetailedView :id="id"/>
      </div>

   </div>

   <!-- <div>
 
       <div class="text-center">
          <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">Page Not Found</li>
             </ol>
          </nav>
       </div>
 
    </div> -->
</template>

<script>
import BlockDetailedView from "@/components/ContentLibrary/BlockView.vue"

export default ({

   components: {
      BlockDetailedView
   },

   props: {
      id: {
         type: String,
      },
      block_type: {
         type: String,
      }
   },

   data() {
      return {
         title: "",
         organisationId: 0,
      }
   },

   computed: {
      item() {
         return this.id
      },

      currentOrg() {
         return this.$store.state.auth.currentOrganisation.id
      }

   },

   watch: {
      item() {
         this.init()
      },
   },

   created() {
      this.organisationId = this.$store.state.auth.currentOrganisation.id
      this.title = this.block_type
   },

   methods: {
      goToMainPage() {
         this.$router.push({ name: 'content_library_blocks' })
      }
   },
})
</script>

<style scoped>
.clickable-row:hover {
   text-decoration: underline;
}
</style>